<script>
import axios from '@/utils/axios';
import { permissionsMixin } from '@/mixins/userPermissions';
import { useMasterDataStore } from '@/stores/useMasterDataStore';

export default {
 inject: ['setLoading'], 
  data() {
   return {
    errors: {},
    low_stock_threshold: 0,
    price_adjustment_restriction: 'none',
    title: "Settings",
    text: "Administration",
    text1: "Settings",
    // currencies: [],
    tax_type: '',
    currency: '',
    allow_inventory_variance: false,
    lead_assignment_mode: '',
    dc_customer_visibility_control: false,
    allowed_recipient_in_dc: [],
    recipientOptions: [
      { label: 'Engineer', value: 'App\\Models\\Engineer' },
      { label: 'Customer', value: 'App\\Models\\Customer' },
      { label: 'Sales Executive', value: 'App\\Models\\SalesExecutive' },
      { label: 'Internal Consumption', value: 'App\\Models\\InternalConsumption' },
    ],
   };
 },

  mixins: [permissionsMixin],

  // methods: {
  //   isActive(path) {
  //     return this.$route.path === path;
  //   },
  // },

  computed: {
  currencies() { return useMasterDataStore().currencies || [] },
},

 mounted(){
  this.getCurrencies();
  this.setPermissions(this.auth);
  //PREFILL VALUES
  this.tax_type = this.clientSetting?.tax_type || '';
  this.allow_inventory_variance = this.clientSetting?.allow_inventory_variance || false;
  this.low_stock_threshold = this.clientSetting?.low_stock_threshold || 0;
  this.lead_assignment_mode = this.clientSetting?.lead_assignment_mode || 'source';
  this.dc_customer_visibility_control = this.clientSetting?.dc_customer_visibility_control == 1 ? true : false;
  this.price_adjustment_restriction = this.clientSetting?.price_adjustment_restriction || 'none';
  const savedRecipients = this.clientSetting?.allowed_recipient_in_dc;
  if (savedRecipients) {
    this.allowed_recipient_in_dc = typeof savedRecipients === 'string' ? savedRecipients.split(',') : savedRecipients;
  }
 },

 methods: {

    isActive(path) {
    return this.$route.path === path;
  },

  // async getCurrencies(){
  //  this.setLoading(true);
  //  try{
  //   const response = await axios.get('currencies');
  //   this.currencies = response.data.data;
  //   this.currency = this.currencies.find(c => c.id === this.clientSetting?.currency_id);
  //  }catch(error){
  //   console.log(error.message);
  //  }finally{
  //   this.setLoading(false);
  //  }
  // },

  async getCurrencies(){
  await useMasterDataStore().loadAll()
  this.currency = this.currencies.find(c => c.id === this.clientSetting?.currency_id);
},

  async submitForm(){
   this.errors = {};
   this.setLoading(true);
   try{
    const response = await axios.put('/configurations', {
     tax_type: this.tax_type,
     currency_id: this.currency?.id,
     allow_inventory_variance: this.allow_inventory_variance,
     low_stock_threshold: this.low_stock_threshold,
     lead_assignment_mode: this.lead_assignment_mode,
     dc_customer_visibility_control: this.dc_customer_visibility_control,
     price_adjustment_restriction: this.price_adjustment_restriction,
     allowed_recipient_in_dc: this.allowed_recipient_in_dc.join(','),
    });

    const client_setting = response.data.data;
    localStorage.setItem('client_setting', JSON.stringify(client_setting));
    this.$swalToast(response.data.message);
   }catch(error){
    if(error.type == 'validation'){
     this.errors = error.errors;
    }else{
     this.$swalToast(error.message, 'error');
    }    
   }finally{
    this.setLoading(false);
   }
  },

 },
};
</script>

<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>
<!-- Page Wrapper -->
<div class="page-wrapper">
<div class="content">
<!-- Breadcrumb -->
<div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
<breadcrumb :title="title" :text="text" :text1="text1" />
<div class="head-icons ms-2">
 
</div>
</div>
<!-- /Breadcrumb -->

<settings-tab></settings-tab>
<div class="row">
<others-sidebar></others-sidebar>
<div class="col-xl-9">
<div class="card">
<div class="card-body">
<div class="border-bottom mb-3 pb-3">
  <h4>Configurations</h4>
</div>
<form @submit.prevent="submitForm" enctype="multipart/form-data">
  <div class="border-bottom mb-3">
    <div class="row">
      <div class="col-md-12">
        <!-- <div>
          <h6 class="mb-3">Banking Information</h6>
        </div> -->
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="row align-items-center mb-3">
          <div class="col-md-4">
            <label class="form-label mb-md-0">Tax Type</label>
          </div>
          <div class="col-md-8">
            <input type="radio" class="form-check-input" name="tax_type" id="inclusive" value="inclusive" v-model="tax_type" /> <label for="inclusive" class="me-2">Inclusive</label>
            <input type="radio" class="form-check-input" name="tax_type" id="exclusive" value="exclusive" v-model="tax_type" /> <label for="exclusive">Exclusive</label>
            <div class="text-danger small mt-1" v-if="errors.tax_type">{{errors.tax_type[0]}}</div>
          </div>
        </div>
      </div>
    
      <div class="col-md-6" v-if="getPermission('Stock', 'read')">
        <div class="row align-items-center mb-3">
          <div class="col-md-8">
            <label class="form-label mb-md-0">Allow Inventory Variance</label>
          </div>
          <div class="col-md-4">
            <div class="form-check form-switch d-flex mb-2">
            <input class="form-check-input m-0" type="checkbox" id="send_on_sms" v-model="allow_inventory_variance" @change="submitForm">
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="row align-items-center mb-3">
          <div class="col-md-4">
            <label class="form-label mb-md-0">Currency</label>
          </div>
          <div class="col-md-8">
            <vue-select :options="currencies" label="name" v-model="currency" />
            <div class="text-danger small mt-1" v-if="errors.currency_id">{{errors.currency_id[0]}}</div>
          </div>
        </div>
      </div>

      <div class="col-md-6" v-if="getPermission('Stock', 'read')">
        <div class="row align-items-center mb-3">
          <div class="col-md-4">
            <label class="form-label mb-md-0">Low Stock Threshold</label>
          </div>
          <div class="col-md-8">
            <input 
              type="number" 
              class="form-control" 
              v-model.number="low_stock_threshold" 
              min="0" 
              placeholder="Enter threshold quantity" 
            />
            <div class="text-danger small mt-1" v-if="errors.low_stock_threshold">
              {{ errors.low_stock_threshold[0] }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="row align-items-center mb-3">
          <div class="col-md-4">
            <label class="form-label mb-md-0">Lead Assignment Mode</label>
          </div>
          <div class="col-md-8">
            <input type="radio" class="form-check-input me-2" name="lead_assignment_mode" id="source_mode" value="source" v-model="lead_assignment_mode" />
            <label for="source_mode" class="me-2">Source</label>
            <input type="radio" class="form-check-input me-2" name="lead_assignment_mode" id="location_mode" value="location" v-model="lead_assignment_mode" />
            <label for="location_mode">Location</label>
            <div class="text-danger small mt-1" v-if="errors.lead_assignment_mode">{{ errors.lead_assignment_mode[0] }}</div>
          </div>
        </div>
      </div>

      <div class="col-md-6" v-if="getPermission('Stock', 'read')">
        <div class="row align-items-center mb-3">
          <div class="col-md-8">
            <label class="form-label mb-md-0">Visibility Control on DC for Customer</label>
          </div>
          <div class="col-md-4">
            <div class="form-check form-switch d-flex mb-2">
              <input class="form-check-input m-0" type="checkbox" id="dc_customer_visibility_control" v-model="dc_customer_visibility_control" @change="submitForm">
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row align-items-center mb-3">
          <div class="col-md-4">
            <label class="form-label mb-md-0">Price Adjustment Restriction</label>
          </div>
          <div class="col-md-8">
            <select class="form-select" v-model="price_adjustment_restriction" @change="submitForm">
              <option value="none">None (Allow All)</option>
              <option value="decrease">Restrict Decrease</option>
              <option value="increase">Restrict Increase</option>
              <option value="both">Restrict Both</option>
            </select>
            <div class="text-danger small mt-1" v-if="errors.price_adjustment_restriction">
              {{ errors.price_adjustment_restriction[0] }}
            </div>
          </div>
        </div>
      </div>  
      <div class="col-md-6" v-if="getPermission('Delivery_Challan', 'read')">
        <div class="row align-items-center mb-3">
          <div class="col-md-4">
            <label class="form-label mb-md-0">Allowed Recipients in DC</label>
          </div>
          <div class="col-md-8">
            <div v-for="opt in recipientOptions" :key="opt.value" class="d-flex align-items-center justify-content-between mb-2">
              <span style="font-size:13px; color:#333;">{{ opt.label }}</span>
              <div class="form-check form-switch">
                <input 
                  class="form-check-input m-0" 
                  type="checkbox" 
                  :value="opt.value" 
                  v-model="allowed_recipient_in_dc"
                />
              </div>
            </div>
            <div class="text-danger small mt-1" v-if="errors.allowed_recipient_in_dc">
              {{ errors.allowed_recipient_in_dc[0] }}
            </div>
          </div>
        </div>
      </div>    
    </div>
  </div>

  <div class="d-flex align-items-center justify-content-end">
   <!-- <button type="button" class="btn btn-outline-light border me-3"> Cancel </button> -->
   <button type="submit" class="btn btn-primary">Save</button>
  </div>
</form>
</div>
</div>
</div>
</div>
</div>

<app-footer></app-footer>

</div>
<!-- /Page Wrapper -->
</template>
<style scoped>
:deep(.vs__selected) {
  background: #eff6ff !important;
  border: 1px solid #bfdbfe !important;
  border-radius: 6px !important;
  padding: 2px 8px !important;
  font-size: 12px !important;
  color: #1e40af !important;
  margin: 2px 4px 2px 0 !important;
}
:deep(.vs__deselect) {
  fill: #1e40af !important;
  margin-left: 4px;
}
:deep(.vs__dropdown-toggle) {
  min-height: 38px;
  flex-wrap: wrap;
  padding: 4px 8px !important;
}
</style>